<!-- @format -->
<ng-container *ngIf="rating > 0; else noSEOContainer">
	<div
		class="reviews-summary-wrapper hmf-display-flex hmf-flex-column hmf-px-xs"
		itemscope
		itemprop="aggregateRating"
		itemtype="https://schema.org/AggregateRating">
		<ng-container *ngTemplateOutlet="content"></ng-container>
	</div>
</ng-container>

<ng-template #noSEOContainer>
	<div class="reviews-summary-wrapper hmf-display-flex hmf-flex-column hmf-px-s">
		<ng-container *ngTemplateOutlet="content"></ng-container>
	</div>
</ng-template>

<ng-template #content>
	<div
		class="reviews-summary-overview hmf-display-grid"
		[ngClass]="{ 'hmf-px-s': count === 0 }">
		<div
			*ngIf="rating > 0 && productReviewed$ | async as productReviewed"
			itemscope
			itemprop="itemReviewed"
			itemtype="https://schema.org/IndividualProduct">
			<meta
				*ngIf="rating > 0"
				itemprop="name"
				content="{{ productReviewed.name }}" />
		</div>
		<div
			class="reviews-summary-count hmf-display-l"
			data-nosnippet>
			{{ count | number: '1.0-0' }} REVIEWS
		</div>
		<div
			*ngIf="count > 0"
			class="reviews-summary-star-count-container hmf-display-flex hmf-align-items-center hmf-align-self-end hmf-justify-content-xs-between hmf-justify-content-s-flex-end hmf-px-s">
			<div class="hmf-display-flex hmf-align-items-center">
				<div
					class="reviews-summary-number hmf-mr-xxs hmf-header-l"
					data-nosnippet>
					{{ rating | starRatingNumber }}
				</div>
				<meta
					*ngIf="rating > 0"
					itemprop="ratingValue"
					[attr.content]="rating | starRatingNumber" />
				<product-reviews-review-stars
					class="reviews-summary-stars hmf-display-inline-flex"
					[rating]="rating"
					[options]="starsOptions"></product-reviews-review-stars>
			</div>
			<meta
				*ngIf="count > 0"
				itemprop="bestRating"
				content="{{ reviewSummary.overallRatingRange }}" />
			<div
				class="reviews-summary-text hmf-header-s hmf-ml-xxs hmf-pl-s-xxs hmf-pr-s-s"
				data-nosnippet>
				{{ count | number }} Reviews
			</div>
			<meta
				*ngIf="rating > 0"
				itemprop="reviewCount"
				[attr.content]="reviewSummary.reviewCount" />
		</div>
	</div>
	<ng-container *ngIf="!!count">
		<product-reviews-percentage
			class="reviews-summary-recomended-percentage hmf-display-flex hmf-align-items-center hmf-align-items-m-flex-end hmf-mt-s"></product-reviews-percentage>
	</ng-container>
</ng-template>
